import React from 'react'
import PropTypes from 'prop-types'
import {
  ControlsBox,
  FormAdd,
  FormInputNumberInputWrapper,
  FormSubtract,
  Input,
  Vr,
} from './component.styles'

const normalizeNumberInputValue = rawValue => {
  if (rawValue === '') {
    return ''
  }
  // Reject non-numeric keystrokes (allow intermediate "-" / ".")
  if (!/^-?\d*\.?\d*$/.test(rawValue)) {
    return null
  }
  if (rawValue === '-' || rawValue.endsWith('.')) {
    return rawValue
  }
  const numericValue = Number(rawValue)
  if (!Number.isFinite(numericValue)) {
    return rawValue
  }
  return String(numericValue)
}

const FormInputNumberInput = ({
  dataTestId,
  disabled,
  hasError,
  onChange,
  placeholder,
  value,
}) => {
  const displayValue = value === null || value === undefined ? '' : value

  return (
    <FormInputNumberInputWrapper>
      <Input
        dataTestId={dataTestId}
        disabled={disabled}
        hasError={hasError}
        inputMode="numeric"
        onChange={({ target }) => {
          const normalized = normalizeNumberInputValue(target.value)
          if (normalized === null) {
            return
          }
          onChange(normalized)
        }}
        pattern="[0-9]*"
        placeholder={placeholder}
        type="text"
        value={displayValue}
      />
      <ControlsBox>
        <FormSubtract
          disabled={disabled}
          onClick={() => !disabled && onChange(Number(value) - 1)}
          onKeyUp={event => {
            if (event.key === 'Enter') {
              onChange(Number(value) - 1)
            }
          }}
        />
        <Vr noshade />
        <FormAdd
          disabled={disabled}
          onClick={() => !disabled && onChange(Number(value) + 1)}
          onKeyUp={event => {
            if (event.key === 'Enter') {
              onChange(Number(value) + 1)
            }
          }}
        />
      </ControlsBox>
    </FormInputNumberInputWrapper>
  )
}

FormInputNumberInput.propTypes = {
  dataTestId: PropTypes.string,
  disabled: PropTypes.bool,
  hasError: PropTypes.bool,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
}

export default FormInputNumberInput
